import {
  resolveCategoryAttributeDisplayLabel,
} from './categoryAttributeFilters';

// Dictionnaire local minimal pour quelques clés courantes
const DEFAULT_LABELS: Record<string, string> = {
  brand: 'Marque',
  color: 'Couleur',
  size: 'Taille',
  capacity: 'Capacité',
  model: 'Modèle',
  serialNumber: 'Numéro de série',
  // Alias FR fréquents
  marque: 'Marque',
  couleur: 'Couleur',
  taille: 'Taille',
  modele: 'Modèle',
  numero_serie: 'Numéro de série',
  secret_clues: 'Détail secret',
  // État / condition
  condition: 'État',
  etat: 'État',
  // Matériau
  material: 'Matériau',
  materiau: 'Matériau',
  // Stockage / emplacement
  storage: 'Stockage',
  storageLocation: 'Lieu de stockage',
  lieu_stockage: 'Lieu de stockage',
  // Dimensions / poids
  weight: 'Poids',
  height: 'Hauteur',
  width: 'Largeur',
  length: 'Longueur',
  depth: 'Profondeur',
  // Appareils électroniques
  imei: 'IMEI',
  os: 'Système',
  screenSize: 'Taille d’écran',
  battery: 'Batterie',
};

function humanizeKey(rawKey: string): string {
  if (!rawKey) return '';
  // Remplacer underscores par espaces, découper camelCase, mettre majuscule
  const spaced = rawKey
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function formatAttributeLabel(
  attributeKey: string,
  options?: {
    categoryAttributes?: Record<string, any> | null;
    objectAttributes?: Record<string, unknown> | null;
    providerTemplateFields?: Record<string, any> | null;
    localDict?: Record<string, string>;
  }
): string {
  const key = attributeKey;
  const { categoryAttributes, objectAttributes, providerTemplateFields, localDict } = options || {};

  // 1) Label depuis la catégorie active (y compris conditional_labels)
  if (categoryAttributes && categoryAttributes[key]) {
    return resolveCategoryAttributeDisplayLabel(key, categoryAttributes, objectAttributes);
  }

  // 2) Label depuis le template de partenaire (champs de lieu)
  if (providerTemplateFields && providerTemplateFields[key] && providerTemplateFields[key].label) {
    return String(providerTemplateFields[key].label);
  }

  // 3) Dictionnaire local fourni
  if (localDict && localDict[key]) {
    return localDict[key];
  }

  // 4) Dictionnaire par défaut
  if (DEFAULT_LABELS[key]) {
    return DEFAULT_LABELS[key];
  }

  // 5) Fallback humanize
  return humanizeKey(key);
}

export function humanizeAttributeKey(attributeKey: string): string {
  return humanizeKey(attributeKey);
}


